import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore from 'swiper';

const DiscoverTitle = ({
  isPack,
  titleTextList,
  setThumbsSwiper,
}: {
  isPack?: boolean;
  titleTextList: string[];
  setThumbsSwiper: React.Dispatch<React.SetStateAction<SwiperCore | null>>;
}) => {
  return (
    <div className="title-wrap">
      <h2 className="title-wrap__title">
        <i className="icon-title"></i>
        {isPack ? 'AI 콘텐츠 추천' : 'AI 검색'}
      </h2>
      <div className="title-wrap__contents">
        <p>AI가 통화 내용을 분석해</p>
        <div className="discover-title-slider">
          <Swiper
            onSwiper={setThumbsSwiper}
            direction={'vertical'}
            slidesPerView={1}
            allowTouchMove={false}
            observer={true}
            observeParents={true}
            speed={800}
          >
            {titleTextList.map((titleText, index) => (
              <SwiperSlide key={`title-text-${index}`}>
                <p className="search-text">
                  <span>{titleText}</span>
                </p>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default DiscoverTitle;
